import { RootState } from '../reducers/rootReducer';

export const getLanguageState = (state: RootState) => state.language;

export const getCurrentLanguage = (state: RootState) => getLanguageState(state).currentLanguage;
export const getCurrentLanguageLocale = (state: RootState) => getCurrentLanguage(state).locale;
export const getAvailableLanguages = (state: RootState) => getLanguageState(state).languages;
